<script lang="ts">
	import arrowRight from '$lib/assets/images/icons/arrow-right-purple.svg';
	import chatBubbles from '$lib/assets/images/icons/chat-bubbles.svg';
	import paper from '$lib/assets/images/icons/paper.svg';
	import thumbsUp from '$lib/assets/images/icons/thumbs-up.svg';
	import checkmark from '$lib/assets/images/icons/checkmark.svg';
	import __ from '$lib/stores/TranslationStore';
</script>

<div class="bg-secondary-light">
	<div class="container mx-auto pt-16">
		<div class="flex flex-col justify-between gap-4 lg:flex-row">
			<h3 class="text-2xl text-dark lg:text-5xl">{$__('Como funciona?')}</h3>
			<a
				href="#contacto"
				class="flex items-center gap-3 text-xs font-semibold uppercase tracking-0.14 text-secondary-bright lg:text-lg"
			>
				{$__('Fazer simulação')}
				<img src={arrowRight} alt="fazer simulação" />
			</a>
		</div>
	</div>
	<div class="container mx-auto py-16">
		<div class="flex flex-col justify-around gap-14 lg:flex-row lg:gap-24 lg:pb-24">
			<div>
				<img class="max-h-8 lg:max-h-full" src={chatBubbles} alt="simulação do crédito" />
				<h4 class="mt-9 text-2xl font-semibold text-dark lg:text-4xl">
					{$__('Diga-nos o que precisa')}
				</h4>
				<p class="mt-8 text-lg leading-6 text-dark">
					{$__(
						'O primeiro passo é conhecê-lo. O seu agente irá analisar a sua situação individual, entender as suas necessidades e encaminhá-lo para as soluções mais inteligentes para si.'
					)}
				</p>
			</div>
			<div>
				<img class="max-h-8 lg:max-h-full" src={paper} alt="escolha da proposta" />
				<h4 class="mt-9 text-2xl font-semibold text-dark lg:text-4xl">
					{$__('A proteção certa')}
				</h4>
				<p class="mt-8 text-lg leading-6 text-dark">
					{$__(
						'Deixe o seu agente procurar e negociar o seguro com mais vantagens e coberturas à sua medida. Analise as propostas e escolha a melhor para si!'
					)}
				</p>
			</div>
			<div>
				<img class="max-h-8 lg:max-h-full" src={thumbsUp} alt="validação do projeto" />
				<h4 class="mt-9 text-2xl font-semibold text-dark lg:text-4xl">
					{$__('Sem burocracia')}
				</h4>
				<p class="mt-8 text-lg leading-6 text-dark">
					{$__(
						'O seu agente Poupança no Minuto trata de toda a burocracia por si até o processo estar finalizado.'
					)}
				</p>
			</div>
			<div>
				<img class="max-h-8 lg:max-h-full" src={checkmark} alt="formalização do crédito" />
				<h4 class="mt-9 text-2xl font-semibold text-dark lg:text-4xl">
					{$__('Agora está protegido!')}
				</h4>
				<p class="mt-8 text-lg leading-6 text-dark">
					{$__('O seu seguro está contratado, e o futuro da sua família protegido.')}
				</p>
			</div>
		</div>
	</div>
</div>
